export default "__VITE_ASSET__DX3hpVv4__"